import select2 from 'select2';
import './../../../node_modules/select2/dist/css/select2.css';
import './../../../node_modules/select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.css';

/* global naja, $, intervalFunction */
class Select2Extension {
    init()
    {
        this.initSelect2();
    }
    initSelect2()
    {
        // Oprava pro čtečky čárových kódů (zejména Android/mobil), které vkládají
        // text asynchronně přes IME a Enter (keydown) odpálí dřív, než text doteče
        // do vyhledávacího pole. Nativní Enter pak vybere prázdno a tag/SN nevznikne.
        // Řešení: prázdný Enter zadržíme (capture fáze) a po doteku textu Enter
        // přehrajeme, takže select2 vybere/vytvoří už hotovou položku.
        const attachScannerEnterFix = (searchField) => {
            const field = searchField[0];
            if (!field) {
                return;
            }

            if (field._scannerEnterFix) {
                field.removeEventListener('keydown', field._scannerEnterFix, true);
            }

            const swallow = (e) => {
                const code = e.which || e.keyCode;
                // Navigace v seznamu klávesnicí (šipky, PageUp/Down, Home/End) → uživatel
                // vybírá položku ručně. Zapamatuj si to a Enter pak nech projít nativně.
                if (code === 38 || code === 40 || code === 33 || code === 34 || code === 36 || code === 35) {
                    field._scannerArrowUsed = true;
                    return;
                }
                if (code !== 13) {
                    return;
                }
                if (field._scannerArrowUsed) {
                    // Uživatel se v seznamu pohyboval šipkami → Enter vybere zvýrazněnou
                    // položku nativně, nesmíme ho zadržet.
                    return;
                }
                if ((field.value || '').trim() !== '') {
                    // Text už v poli je → nech Enter projít nativně do select2.
                    return;
                }

                // Enter předběhl vložení textu → zadrž ho a počkej, až text doteče.
                e.preventDefault();
                e.stopImmediatePropagation();

                const $field = $(field);
                let commitTimer = null;
                let giveUpTimer = null;
                const cleanup = () => {
                    $field.off('input.scannerEnter');
                    if (commitTimer) clearTimeout(commitTimer);
                    if (giveUpTimer) clearTimeout(giveUpTimer);
                };
                const replayEnter = () => {
                    ['keydown', 'keypress', 'keyup'].forEach((type) => {
                        $field.trigger($.Event(type, {which: 13, keyCode: 13, key: 'Enter'}));
                    });
                };
                const onInput = () => {
                    // Dorazil text → jde o čtečku, zruš pojistku pro ruční Enter.
                    if (giveUpTimer) {
                        clearTimeout(giveUpTimer);
                        giveUpTimer = null;
                    }
                    if (commitTimer) clearTimeout(commitTimer);
                    // Krátká prodleva sjednotí i čtečky, co posílají znaky postupně.
                    commitTimer = setTimeout(() => {
                        cleanup();
                        if ((field.value || '').trim() === '') {
                            return;
                        }
                        replayEnter();
                    }, 60);
                };
                // Když do téhle doby nedorazí žádný text, nešlo o čtečku, ale o ruční
                // Enter (např. hned po otevření) → přehraj Enter a vyber zvýrazněnou
                // (první) položku seznamu.
                giveUpTimer = setTimeout(() => {
                    cleanup();
                    replayEnter();
                }, 200);
                $field.off('input.scannerEnter').on('input.scannerEnter', onInput);
            };

            field._scannerEnterFix = swallow;
            field.addEventListener('keydown', swallow, true);
        };

        $('.select2-init').each(
            function () {
                if (!$(this).hasClass('select2-hidden-accessible')) {
                    const options = {
                        theme: 'bootstrap-5',
                    };

                    // Přidej placeholder support
                    const placeholder = $(this).data('placeholder') || $(this).attr('placeholder');
                    if (placeholder) {
                        options.placeholder = placeholder;
                        options.allowClear = true;
                    }

                    if ($(this).closest('.modal').length){
                        options.dropdownParent = $(this).closest('.modal');
                    }

                    if ($(this).attr('multiple')) {
                        options.templateResult = function (data) {
                            if (!data.id) return data.text;
                            if (data.element && data.element.selected) return null;
                            return data.text;
                        };
                        options.matcher = function (params, data) {
                            if ($.trim(params.term) === '') {
                            } else {
                                if (typeof data.text === 'undefined') {
                                    return null;
                                }

                                if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) === -1) {
                                    return null;
                                }
                            }

                            if (data.element && data.element.selected) {
                                return null;
                            }

                            return data;
                        };
                    }

                    if ($(this).hasClass('select2-serial-numbers') || $(this).hasClass('select2-tags-init')) {
                        $(this).on('select2:selecting', function (e) {
                            const data = e.params.args.data;
                            const selectedValues = $(this).val() || [];
                            if (selectedValues.includes(data.id)) {
                                e.preventDefault();
                                $(this).select2('close');

                                const flashMessage = $('<div class="alert-danger alert mt-3 alert-dismissible fade show">Sériové číslo již existuje<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>');
                                $('.alert-fixed').append(flashMessage);
                                setTimeout(function () {
                                    flashMessage.find('.btn-close').click();
                                }, 6000);
                            }
                        });
                    }

                    if ($(this).hasClass('select2-serial-numbers')) {
                        options.language = {
                            noResults: function () {
                                return "<p class=\"alert alert-danger\">Sériové číslo nenalezeno</p>";
                            }
                        };
                        options.escapeMarkup = function (markup) {
                            return markup;
                        };
                    }

                    $(this).select2(
                        options
                    );

                    $(this).on('select2:open', function () {
                        const searchField = $('.select2-container--open .select2-search__field');
                        if (searchField.length) {
                            searchField[0].focus();
                            attachScannerEnterFix(searchField);

                            const $select = $(this);
                            if ($select.hasClass('select2-serial-numbers') || $select.hasClass('select2-tags-init')) {
                                searchField.off('keydown.duplicateCheck').on('keydown.duplicateCheck', function (e) {
                                    if (e.which === 13) {
                                        const val = $(this).val();
                                        const selectedValues = $select.val() || [];
                                        if (val && selectedValues.includes(val)) {
                                            const flashMessage = $('<div class="alert-danger alert mt-3 alert-dismissible fade show">Sériové číslo již existuje<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>');
                                            $('.alert-fixed').append(flashMessage);
                                            setTimeout(function () {
                                                flashMessage.find('.btn-close').click();
                                            }, 6000);
                                        }
                                    }
                                });
                            }
                        }
                    });

                    $(this).on('select2:select', function (e) {
                        const selectedValue = e.params.data.id;
                        if (selectedValue === 'clearFilter') {
                            $(this).val(null).trigger('change');
                        }
                    });
                }
            }
        );

        $('.select2-color-init').each(
            function () {
                if ($(this).hasClass('select2-hidden-accessible')) {
                    return;
                }

                const formatColor = function (state) {
                    if (!state.id) {
                        return state.text;
                    }
                    const color = $(state.element).data('color') || state.id;
                    const hex = String(color).replace('#', '');
                    const r = parseInt(hex.substr(0, 2), 16);
                    const g = parseInt(hex.substr(2, 2), 16);
                    const b = parseInt(hex.substr(4, 2), 16);
                    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
                    return $('<span></span>')
                        .text(state.text)
                        .css({
                            'display': 'block',
                            'padding': '2px 8px',
                            'border-radius': '3px',
                            'background-color': color,
                            'color': luminance > 150 ? '#000000' : '#ffffff'
                        });
                };

                const colorOptions = {
                    theme: 'bootstrap-5',
                    minimumResultsForSearch: Infinity,
                    templateResult: formatColor,
                    templateSelection: formatColor,
                    placeholder: $(this).data('placeholder') || 'Poslední barvy…'
                };

                if ($(this).closest('.modal').length) {
                    colorOptions.dropdownParent = $(this).closest('.modal');
                }

                $(this).select2(colorOptions);

                $(this).on('select2:select', function (e) {
                    const color = $(e.params.data.element).data('color') || e.params.data.id;
                    const input = $(this).closest('.mb-3').find('input[type=color]')[0];
                    if (input) {
                        input.value = color;
                        input.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                });
            }
        );

        $('.select2-tags-init').each(
            function () {
                if (!$(this).hasClass('select2-hidden-accessible')) {
                    const options = {
                        theme: 'bootstrap-5',
                        tags: true,
                    };

                    // Přidej placeholder support i pro tags
                    const placeholder = $(this).data('placeholder') || $(this).attr('placeholder');
                    if (placeholder) {
                        options.placeholder = placeholder;
                        options.allowClear = true;
                    }

                    if ($(this).closest('.modal').length){
                        options.dropdownParent = $(this).closest('.modal');
                    }

                    if ($(this).attr('multiple')) {
                        options.templateResult = function (data) {
                            if (!data.id) return data.text;
                            if (data.element && data.element.selected) return null;
                            return data.text;
                        };
                        options.matcher = function (params, data) {
                            if ($.trim(params.term) === '') {
                            } else {
                                if (typeof data.text === 'undefined') {
                                    return null;
                                }

                                if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) === -1) {
                                    return null;
                                }
                            }

                            if (data.element && data.element.selected) {
                                return null;
                            }

                            return data;
                        };
                    }

                    $(this).on('select2:selecting', function (e) {
                        const data = e.params.args.data;
                        const selectedValues = $(this).val() || [];
                        if (selectedValues.includes(data.id)) {
                            e.preventDefault();
                            $(this).select2('close');

                            const flashMessage = $('<div class="alert-danger alert mt-3 alert-dismissible fade show">Sériové číslo již existuje<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>');
                            $('.alert-fixed').append(flashMessage);
                            setTimeout(function () {
                                flashMessage.find('.btn-close').click();
                            }, 6000);
                        }
                    });

                    $(this).select2(
                        options
                    );


                    $(this).on('select2:open', function () {
                        const searchField = $('.select2-container--open .select2-search__field');
                        if (searchField.length) {
                            searchField[0].focus();
                            attachScannerEnterFix(searchField);

                            const $select = $(this);
                            searchField.off('keydown.duplicateCheck').on('keydown.duplicateCheck', function (e) {
                                if (e.which === 13) {
                                    const val = $(this).val();
                                    const selectedValues = $select.val() || [];
                                    if (val && selectedValues.includes(val)) {
                                        const flashMessage = $('<div class="alert-danger alert mt-3 alert-dismissible fade show">Sériové číslo již existuje<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>');
                                        $('.alert-fixed').append(flashMessage);
                                        setTimeout(function () {
                                            flashMessage.find('.btn-close').click();
                                        }, 6000);
                                    }
                                }
                            });
                        }
                    });

                    var s = $(this);
                    const selectedValues = $(this).find(':selected').map(function () {
                        return $(this).val();
                    }).get();

                    setTimeout(function () {
                        s.val(selectedValues).trigger('change');
                    }, 300);
                }
            }
        );
    }
    initialize(naja)
    {
        naja.addEventListener('complete', this.initSelect2.bind(this));
    }
}

export default Select2Extension;
